import React from 'react'
import createReactClass from 'create-react-class'
import EditTranslationsModalPanel from '../modal-panels/edit-translations-modal-panel'

export default createReactClass({
  getInitialState () {
    return {
      showModal: false,
    }
  },
  onRefreshTokenClick () {
    this.setState({
      showModal: true,
    })
  },
  openModal () {
    this.setState({
      showModal: true,
    })
  },
  closeModal () {
    this.setState({
      showModal: false,
    })
  },
  renderModalPanel () {
    if (this.state.showModal) {
      return (
        <EditTranslationsModalPanel translations = {this.props.translations} closeModal={this.closeModal}
          update={this.props.update} index={this.props.index} loader = {this.props.loader}/>
      )
    }
    return false
  },
  render () {
    const editIconStyle = {color: 'red', fontSize: '20px'}
    return (
      <span>
        <a className="fa fa-pencil-square-o" style={editIconStyle}
          onClick={() => this.openModal()}>
        </a>
        {this.renderModalPanel()}
      </span>
    )
  },
  componentWillReceiveProps (nextProps) {
    if (nextProps.isUpdated) {
      this.closeModal()
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/monitoring-translations/edit-translation-icon-panel.js